import angular from 'angular';
import Components from './components/components';
import AppComponent from './app.component';
import 'material-design-icons/iconfont/material-icons.css';
import 'angular-material/modules/closure/toast/toast.css';

require('angular-material');

angular.module('tecobiWidgetsApp', [
    Components
  ])
  .config(($locationProvider, $mdThemingProvider, $interpolateProvider) => {
    "ngInject";
    // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
    // #how-to-configure-your-server-to-work-with-html5mode
    // $locationProvider.html5Mode(true).hashPrefix('!');

    // Change  double curly braces to {% var %} for angularJS because it conflicts with Mustache on client site
    $interpolateProvider.startSymbol('{%');
    $interpolateProvider.endSymbol('%}');

    // Extend the red theme with a different color and make the contrast color black instead of white.
    // For example: raised button text will be black instead of white.
    const tecobiGreenMap = $mdThemingProvider.extendPalette('green', {});

    // Register the new color palette map with the name <code>neonRed</code>
    $mdThemingProvider.definePalette('tecobiGreen', tecobiGreenMap);

    // Use that theme for the primary intentions
    $mdThemingProvider.theme('default').primaryPalette('tecobiGreen');
  })

  .component('app', AppComponent);

// Hack for https://www.thecarshoppeny.com disappearing data-hide="1" slider images
angular.element('#homepageSlide li a img[data-hide]').removeAttr('data-hide');

angular.bootstrap(document.getElementById('tecobi-root'), ['tecobiWidgetsApp']);

// Console stuff
let tecobiMainStyle="font-size:34px; font-weight:200; letter-spacing:0.02em; line-height:1.4em; font-family:helvetica,arial; color:rgba(0,0,0,0.9);";
let tecobiMessageStyle="font-size:21px; font-weight:200; letter-spacing:0.2em; line-height:1.4em; font-family:helvetica,arial; color:rgba(0,0,25,0.5);";
let asciiTecobi = `
  _______ ______ _____ ____  ____ _____
 |__   __|  ____/ ____/ __ \\|  _ \\_   _|
    | |  | |__ | |   | |  | | |_) || |
    | |  |  __|| |   | |  | |  _ < | |
    | |  | |___| |___| |__| | |_) || |_
    |_|  |______\\_____\\____/|____/_____|

`;
console.log(asciiTecobi);
console.log("%cConnect with New Customers Instantly!",tecobiMessageStyle),
console.log("%chttps://tecobi.com/",tecobiMessageStyle),
console.log("%c","font-size:34px; line-height:1.4em;");
// Remove injected material style tags
var tecobiMdStyleNodeList = document.querySelectorAll('[md-theme-style]');
Array.prototype.forEach.call(tecobiMdStyleNodeList, function( node ) {
    node.parentNode.removeChild( node );
});



// WEBPACK FOOTER //
// ./client/app/app.js